import * as React from 'react';
import PropTypes from 'prop-types';
import { IconContainer, InfoNoticeContent } from './InfoNotice.styled';

const InfoNotice = ({ icon, message, counter, ...props }) => {
  return (
    <InfoNoticeContent {...props}>
      {icon && <IconContainer>{icon}</IconContainer>}
      <span>{message}</span>
    </InfoNoticeContent>
  );
};

InfoNotice.propTypes = {
  icon: PropTypes.node,
  message: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]).isRequired,
  counter: PropTypes.number,
};

InfoNotice.defaultProps = {
  icon: null,
  counter: null,
};

export default InfoNotice;
